'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$17() {
  this.bfa = null;
  this.bf8 = null;
  this.bf9 = false;
  this.bf6 = null;
  this.bf7 = false;
  this.bfb = false;
  this.bfc = false;
  this.bfa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$17 as $c_Lpresto_PrestoRouter$$anon$17 };
$p = $c_Lpresto_PrestoRouter$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$17;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$17() {
}
export { $h_Lpresto_PrestoRouter$$anon$17 as $h_Lpresto_PrestoRouter$$anon$17 };
$h_Lpresto_PrestoRouter$$anon$17.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bfa;
});
$p.t = (function() {
  if ((!this.bf9)) {
    this.bf8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bf9 = true;
  }
  return this.bf8;
});
$p.ae = (function() {
  if ((!this.bf7)) {
    this.bf6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bf7 = true;
  }
  return this.bf6;
});
$p.w = (function() {
  if ((!this.bfc)) {
    this.bfb = false;
    this.bfc = true;
  }
  return this.bfb;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$17, "presto.PrestoRouter$$anon$17", ({
  NG: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$17 as $d_Lpresto_PrestoRouter$$anon$17 };
//# sourceMappingURL=presto.-Presto-Router$$anon$17.js.map
